import * as angular from "angular";
import { SurveyDataProvider } from "../../../data-provider/survey.dp";
import { DialogUtils } from "../../../helper/dialog.helper";

let CanvassSurveyComponent = {
    selector: "vcCanvassSurvey",
    templateUrl:
        "/angular/components/canvass/modals/canvass-survey.component.html",
    bindings: {
        selectedSurvey: "=",
    },
    controller: class CanvassSurveyController {
        public error: string | null = null;
        public loading = true;
        public survey: any;
        public surveys: any[] = [];
        public publishedSurveys: any = [];
        public missingRequiredQuestion: string | number | undefined = undefined;

        private dialog: DialogUtils;
        private surveyDataProvider: SurveyDataProvider;

        constructor(
            DialogUtils: DialogUtils,
            SurveyDataProvider: SurveyDataProvider
        ) {
            this.dialog = DialogUtils;

            this.surveyDataProvider = SurveyDataProvider;

            this.surveyDataProvider.getAllSurveys().then((surveys: any) => {
                this.loading = false;
                this.surveys = surveys;
                this.publishedSurveys = this.surveys.filter(
                    (survey) => survey.sstatus == "Live"
                );
                angular.forEach(this.publishedSurveys, (survey: any) => {
                    if (!this.survey && survey.signature != 1) {
                        this.survey = survey;
                    }
                });
                this.surveyChanged();
            });
        }

        surveyChanged(): void {
            this.surveyDataProvider
                .surveyInfo(this.survey.sid)
                .then((infoData: any) => {
                    if (infoData) {
                        this.survey.questions = infoData.questions;
                    }
                });
        }

        requiredQuestionsAnswered(): boolean {
            for (let index = 0; index < this.survey.questions.length; index++) {
                const question = this.survey.questions[index];
                if (question.required != 1) continue;

                if (!this.questionAnswered(question)) {
                    this.missingRequiredQuestion = question.sqid;
                    return false;
                }
            }

            this.missingRequiredQuestion = undefined;
            return true;
        }

        questionAnswered(question: any): boolean {
            if (question.atid == 3) {
                return (
                    typeof question.answer != "undefined" &&
                    question.answer.aname != ""
                );
            } else {
                return typeof question.answer != "undefined";
            }
        }

        validSurvey(): boolean {
            if (!this.requiredQuestionsAnswered()) return false;

            let answered_question = 0;

            angular.forEach(this.survey.questions, (value, key) => {
                if (this.questionAnswered(value)) {
                    answered_question++;
                }
            });

            if (answered_question > 0) {
                this.error = null;
                return true;
            } else {
                this.error = "You must answer at least one question";
                return false;
            }
        }

        changeChecklistAnswer(question: any, choice: any): void {
            if (!question.answer) {
                question.answer = [];
            }

            if (choice.checked) {
                question.answer.push(choice);
            } else {
                question.answer = question.answer.filter(
                    (checkedAnswer) => checkedAnswer.aid !== choice.aid
                );
            }

            if (question.answer.length == 0) {
                delete question.answer;
            }
        }

        confirm(): void {
            this.dialog.hide(this.survey);
        }

        cancel(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("canvass")
    .component(CanvassSurveyComponent.selector, CanvassSurveyComponent);
